<template>
  <div class="csu-modal" :style="popboxShow">
    <!-- 弹窗容器 -->
    <div class="csu-modal-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BindQqModal',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    popboxBg: {
      // 弹框背景
      type: String,
    },
    closeBtnConfig: {
      // 关闭按钮配置
      type: String,
      default: '[{}]',
    },
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    };
  },

  computed: {
    popboxShow() {
      return { display: this.isShow ? 'flex' : 'none', position: 'fixed' };
    },
    popboxClass() {
      return ['csu-modal--default', this.isMobile ? 'csu-modal--mobile' : ''];
    },
  },

  mounted() {},
  methods: {
    handleClose() {
      // 弹框关闭
      this.$emit('update:isShow', false);
    },
    handleClickMask() {
      this.handleClose();
    },
  },
};
</script>

<style>

.csu-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}

.csu-modal-content {
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
